import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useRoutes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import Login from './pages/Login/Login';
import "./Style.scss";
import RefreshTokenPopup from "./components/RefreshTokenPopup";
import Loader from "./LoaderContext";
import Header from "./components/Header/Header"; 
import Footer from "./components/Footer/Footer";
import Dashboard from './pages/Dashboard/Dashboard';
import CourseView from './pages/Cources/CourseView';
import QuizzesView from './pages/Quiz/QuizzesView';
import CourseFileView from './pages/CourseFiles/CourseFileView';
import QuestionsView from './pages/Questions/QuestionsView';
import SideBar from "./components/SideBar/SideBar";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import TopicView from './pages/Topic/TopicView';
import ModuleView from './pages/Module/ModuleView';
import BreadcrumbsMenu from '../src/components/Breadcrumb';
import CourseCategoryView from './pages/Cource Category/CourseCategoryView';

// Route configuration
export const routes = [
  { path: "dashboard", headerName: "Dashboard", element: <Dashboard /> },
  { path: "coursecategory", headerName: "Course Category", element: <CourseCategoryView /> },
  { path: "course", headerName: "Course", element: <CourseView /> },
  { path: "coursefiles", headerName: "Course File", element: <CourseFileView /> },
  { path: "questions", headerName: "Questions", element: <QuestionsView /> },
  { path: "quizzes", headerName: "Quizzes", element: <QuizzesView /> },
  { path: "topics", headerName: "Topics", element: <TopicView /> },
  { path: "module", headerName: "Module", element: <ModuleView /> },
];

const App = () => {
  const [currentElementWidth, setCurrentElementWidth] = useState("100%");
  const [currElMargin, setCurrElMargin] = useState("200px");
  const [isLoading, setIsLoading] = useState(false); 
  const [visible, setVisible] = useState(false);
  const token = sessionStorage.getItem("userToken");
  const menus = sessionStorage.getItem("accessMenus");
  const handleDialogVisibility = (isVisible) => setVisible(isVisible);
  const AppRoutes = () => useRoutes(routes);

  const renderLoggedInApp = () => (
    <div>
      <div className="grid">
        <div className="md:col-fixed" style={{ width: currElMargin }}>
          <SideBar menus={JSON.parse(menus)} />
        </div>
        <div
          className="layout-wrapper-div"
          style={{
            width: currentElementWidth,
            marginLeft: currElMargin,
            height: "100vh",
            overflowY: "auto",
          }}
        >
          {/* <Header /> */}
         <BreadcrumbsMenu />
          <AppRoutes />
          <Footer footNotes={"NHM LMS"} />
        </div>
      </div>
    </div>
  );
  const renderLoginRoutes = () => (
    <Routes>
      <Route path="/" element={<Navigate to="/Login" />} />
      <Route path="/Login" element={<Login />} />
    </Routes>
  );
  return (
    <Provider store={store}>
      <Router>
        <Loader isVisible={isLoading} />
        <RefreshTokenPopup visible={visible} onHide={handleDialogVisibility} />
        {token ? renderLoggedInApp() : renderLoginRoutes()}
      </Router>
    </Provider>
  );
};

export default App;